function groupAlphabetically(locations) {
  const grouped = {};

  locations.forEach((location) => {
    const firstChar = location.title[0].toUpperCase();
    if (!grouped[firstChar]) grouped[firstChar] = [];
    grouped[firstChar].push(location);
  });

  return grouped;
}

export default {
  groupAlphabetically,
};
